import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ControlErrorContainerDirective } from './control-error-container.directive';
import { ControlErrorsDirective } from './control-errors.directive';
import { FormSubmitDirective } from './form-submit.directive';
import { ValidationErrorTranslations } from './validation-errors-translations.service';
import { ValidationMessageComponent } from './validation-message.component';

/**
 * Module for all the directives
 */
@NgModule({
  declarations: [
    ControlErrorsDirective,
    ControlErrorContainerDirective,
    FormSubmitDirective,
    ValidationMessageComponent
  ],
  exports: [
    ControlErrorsDirective,
    ControlErrorContainerDirective,
    FormSubmitDirective,
    ValidationMessageComponent
  ],
  providers: [
    ValidationErrorTranslations
  ],
  imports: [
    CommonModule
  ]
})
export class FormValidationModule { }
